/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacetDto } from './FacetDto';
import {
    FacetDtoFromJSON,
    FacetDtoFromJSONTyped,
    FacetDtoToJSON,
    FacetDtoToJSONTyped,
} from './FacetDto';

/**
 * Réponse des routes {domaine}/liste/filtres et {domaine}/admin/liste/filtres. Les options de chaque dimension sont calculées avec tous les filtres courants SAUF celui de la dimension elle-même (règle e-commerce standard), d'où l'importance d'envoyer les filtres courants dans le body.
 * 
 * @export
 * @interface GetFacetsResponse
 */
export interface GetFacetsResponse {
    /**
     * 
     * @type {Array<FacetDto>}
     * @memberof GetFacetsResponse
     */
    facets: Array<FacetDto>;
}

/**
 * Check if a given object implements the GetFacetsResponse interface.
 */
export function instanceOfGetFacetsResponse(value: object): value is GetFacetsResponse {
    if (!('facets' in value) || value['facets'] === undefined) return false;
    return true;
}

export function GetFacetsResponseFromJSON(json: any): GetFacetsResponse {
    return GetFacetsResponseFromJSONTyped(json, false);
}

export function GetFacetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacetsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'facets': ((json['facets'] as Array<any>).map(FacetDtoFromJSON)),
    };
}

export function GetFacetsResponseToJSON(json: any): GetFacetsResponse {
    return GetFacetsResponseToJSONTyped(json, false);
}

export function GetFacetsResponseToJSONTyped(value?: GetFacetsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facets': ((value['facets'] as Array<any>).map(FacetDtoToJSON)),
    };
}

